import { HumanPerformerImpl } from "@edp-bpm/bpmn-common-model";
import { BillCreationType } from "./BillCreationType";
import { BpmnModel, BpmnModelHelper, ExtensionMethod } from "@edp-pmf/bpmn-model";

export class CreationHumanPerformerImpl extends HumanPerformerImpl {
  static CLR_TYPE_ID = "bpmn.CreationHumanPerformerImpl";
  ClrTypeID: string = CreationHumanPerformerImpl.CLR_TYPE_ID;

  billCreationType = BillCreationType.PULL;

  public ConvertToJsonObject() {
    let obj = super.ConvertToJsonObject();
    ExtensionMethod.SetAttributeValue(obj, "billCreationType", this.billCreationType);
    return obj;
  }

  public LoadFromJsonObject(obj: {}): void {
    super.LoadFromJsonObject(obj);

    this.billCreationType = BillCreationType[ExtensionMethod.GetAttributeValue4String(obj, "billCreationType")];
  }

  NewInstance(): CreationHumanPerformerImpl {
    return new CreationHumanPerformerImpl(this.Model);
  }

  clone(): CreationHumanPerformerImpl {
    const humanPerformerImpl = new CreationHumanPerformerImpl(this.Model);

    if (this.participantExpression) {
      humanPerformerImpl.participantExpression = (this.participantExpression as any).clone();
    }
    if (this.condition) {
      humanPerformerImpl.condition = this.condition.clone();
    }
    humanPerformerImpl.order = this.order;
    humanPerformerImpl.billCreationType = this.billCreationType;

    return humanPerformerImpl;
  }
}

BpmnModelHelper.RegisterElementType(new CreationHumanPerformerImpl(new BpmnModel()));
